import { jsonKeyMapping } from '../../../Config/Constants'
import { TemplateObject } from '../../../Models/TemplateObject'
import { removeSemicolons } from '../../../Util/TextUtils'

type Props = {
    formElement: TemplateObject
};

const InputHeading = ({ formElement }: Props) => {
    // Remove semicolons from label text
    const labelText = removeSemicolons(formElement[jsonKeyMapping.FORM_LABEL]);
    
    return (
      <>
     <div className="row"> <label>{labelText}</label>
      {formElement[jsonKeyMapping.FORM_SUBTEXT] && <small>{formElement[jsonKeyMapping.FORM_SUBTEXT]}</small>}</div>
      </>
    )
}

export default InputHeading
